// @flow
import React from 'react';
import {
  Table,
  TableHeader,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import { Banner } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { FormattedMessage } from 'react-intl';
import useIntl from '../../../hooks/useIntl';
import TableLayout from '../../../components/TableLayoutV2';
import { useAdjustmentsTable, useHudVoucherAdjustmentsData } from './hooks';
import messages from './messages';
import { BASE_TABLE_LAYOUT_SX } from '../constants';
import parentMessages from '../messages';

interface AdjustmentsProps {
  show: boolean;
  organizationId?: string;
  propertyId?: string;
  voucherId?: string;
  voucherSubmissionStatus?: string;
  isGated?: boolean;
  hasVariance?: boolean;
  isReadOnly?: boolean;
  onSaveApprovedAmount?: (row: any, amount: number) => void;
  canManage: boolean;
}

function Adjustments({
  show,
  organizationId,
  propertyId,
  voucherId,
  voucherSubmissionStatus,
  isGated = false,
  hasVariance = false,
  isReadOnly = false,
  onSaveApprovedAmount,
  canManage,
}: AdjustmentsProps): React$Node {
  const intl = useIntl();

  const { adjustments, isLoading: isAdjustmentsLoading } =
    useHudVoucherAdjustmentsData({
      show,
      organizationId,
      propertyId,
      voucherId,
      voucherSubmissionStatus,
    });

  const {
    baseTableProps,
    name,
    allColumnsHidden,
    columnOptions,
    filteredHeaders,
    selectedColumns,
    handleColumnChange,
    isLoading,
    rows,
    count,
    totalCount,
  } = useAdjustmentsTable({
    adjustments,
    isLoading: isAdjustmentsLoading,
    hasVariance,
    isReadOnly,
    onSaveApprovedAmount,
    canManage,
  });

  if (!show) {
    return null;
  }

  return (
    <TableLayout name={name} fullPage sx={BASE_TABLE_LAYOUT_SX}>
      {(height) => (
        <>
          <TableHeader
            title={<FormattedMessage {...messages.tableTitle} />}
            count={count}
            totalCount={totalCount}
          />
          {isGated && rows?.length === 0 ? (
            <Banner
              status="warning"
              message={intl.formatMessage(
                parentMessages.rapAdjustmentsGatingBanner,
              )}
            />
          ) : null}
          <Table
            {...baseTableProps}
            name={name}
            allColumnsHidden={allColumnsHidden}
            columnOptions={columnOptions}
            selectedColumns={selectedColumns}
            handleColumnChange={handleColumnChange}
            headers={filteredHeaders}
            isLoading={isLoading}
            rows={rows}
            count={count}
            height={height}
            emptyStateMessage={intl.formatMessage(messages.emptyStateMessage)}
            totalCount={totalCount}
          />
        </>
      )}
    </TableLayout>
  );
}

export default Adjustments;
